// extracted by mini-css-extract-plugin
export default {"container":"videoplayer_container__vxydC"};